import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="hamburger-menu"
export default class extends Controller {
  static targets = ["menu", "backdrop", "menuToggler"];

  connect() {
  }

  open() {
    window.dispatchEvent(new CustomEvent("showMenu"));
  }

  close() {
    window.dispatchEvent(new CustomEvent("closeMenu"));
  }

  handleMenuClosing() {
    this.menuTarget.classList.remove("open");
    this.element.classList.remove("hamburger-open");
  }

  handleMenuOpening() {
    this.menuTarget.classList.add("open");
    this.element.classList.add("hamburger-open");
  }

  toggle(e, open) {
    if (this.element.classList.contains("hamburger-open")) {
      this.close();
    } else {
      this.open();
    }
  }
}
